import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PapiAuthService } from '../services/papi-auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(PapiAuthService);
  const router = inject(Router);
  if (authService.isLoggedIn()) {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};